import { Component } from "@angular/core";
import { ExportBase } from "../export-base";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/export/i18n/scope";

@Component({
    selector: "export-users",
    templateUrl: "./export-users.component.html",
    styleUrls: ["./export-users.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
    imports: [TranslatePipe]
})
export class ExportUsersComponent extends ExportBase {
}
